module.exports = __webpack_public_path__ + "img/English-01.f2d107a7.jpg";